import styled from "styled-components";

export const Container = styled.div`
  margin-top: 10px;
  font-family: Arial, sans-serif;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
`;

export const InfoText = styled.div`
  font-size: 12px;
  line-height: 1.5;
  color: #444; // ciemniejszy niż domyślny czarny, mniej kontrastowy
  background-color: #f9f9f9; // delikatne tło dla oddzielenia od reszty
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 11px;
    padding: 5px;
  }
`;

export const InactiveProgressBar = styled.div`
  background: repeating-linear-gradient(
    45deg,
    #dddddd,
    #dddddd 10px,
    #eeeeee 10px,
    #eeeeee 20px
  );
  height: 100%;
  width: 100%;
  opacity: 0.6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  font-size: 11px;
  font-style: italic;


`;

export const ProgressBarWrapper = styled.div`
  position: relative;
  background-color: #ccc;
  height: 24px;
  overflow: hidden;
  display: flex;
  width: 100%;
  position: relative;
  height: 24px;
  border-radius: 5px;
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  background: radial-gradient(ellipse at center, #f9b3ff 0%, #d46cff);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 1px 5px 8px;
`;

export const ProgressBarBackground = styled.div`
  background-color: #e0e0e0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
`;

export const ProgressText = styled.span`
  font-size: 11px;
  color: black;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 9px;
    padding: 5px;
    text-align: center;
  }
`;

export const OverLimitIndicator = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
background: radial-gradient(
  ellipse at center,
  rgb(225, 110, 135), /* delikatnie ciemniejszy różowy */
  rgba(210, 80, 120, 0.85) 70% /* lekko głębszy malinowy */
);
box-shadow: 0 0 10px rgba(180, 60, 100, 0.35);
  box-shadow: 0 0 12px rgba(100, 0, 50, 0.4);
  display: flex;
  align-items: center;
  padding: 0 6px;
  font-size: 11px;

`;
